<template>
    <div id="check">
        <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800&display=swap" rel="stylesheet">
        <link href="/static/css/general/style-cabinet-avtoservice.css" rel="stylesheet" />
        <service-messages :user.sync="user" :city.sync="city" :auth.sync="auth" :service.sync="service" :leads.sync="leads" v-if="auth.role === 1"/>
        <user-messages  :user.sync="user" :city.sync="city" :auth.sync="auth" :leads.sync="leads" v-if="auth.role === 0"/>
    </div>
</template>

<script>
import ServiceMessages from '@/components/cabinet/service/messages'
import UserMessages from '@/components/cabinet/user/messages'
export default {
  name: 'check.vue',
  props: ['city', 'user', 'auth', 'service', 'leads'],
  components: {
    ServiceMessages,
    UserMessages
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cabinet/messages.vue